module.exports = __webpack_public_path__ + "img/text-mark13.cbfa2dfa.png";